import React from "react";
import { skills } from "../data";
import { BadgeCheckIcon } from "@heroicons/react/solid";

export default function About() {
    return (
        <section id="about">
            <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
                <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
                    <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
                        Hi, I'm Daniel
                        <br className="hidden lg:inline-block"></br>
                    </h1>
                    <p className="mb-8 leading-relaxed">
                        I'm a passionate programmer who's just finished a degree in computer science, getting a first. I have experience in a range of tools and languages
                        and enjoy solving problems. I'm currently looking for emplyment to further my skills. I am interested and have experince in all aspects of the development 
                        lifecycle, whether it is frontend, backend, fullstack or devOps.
                    </p>
                    <div className="flex justify-center pb-10">
                        <a
                            href='#contact'
                            className="inline-flex text-white bg-green-500 border-0 py-2 px-4 focus:outline-none hover:bg-green-600 rounded text-lg">
                            Work With Me
                        </a>
                        <a
                            href='#projects'
                            className="ml-4 inline-flex text-gray-400 bg-gray-900 border-0 py-2 px-4 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
                            Past Work
                        </a>
                        <a href="https://docs.google.com/document/d/1S6yH2A2rFegk65YUQ5WqfwLRsWDDdlNQ/edit?usp=sharing&ouid=108375138709124241297&rtpof=true&sd=true"
                            className="ml-4 inline-flex text-gray-400 bg-gray-900 border-0 py-2 px-4 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
                            CV
                        </a>
                    </div>
                    <div className="lg:max-w-lg lf-w-full md:w-1/2 w-5/6">
                        <img
                            className="object-cover object-center rounded"
                            alt="hero"
                            src="./coding.svg"
                        />
                    </div>
                </div>
                <div className="flex flex-wrap lg:w-1/2 sm:mx-auto sm:mb-2 -mx-2">
                    {skills.map((skill) => (
                            <div key={skill} className="p-2 sm:w-1/2 w-full">
                                <div className="bg-gray-900 rounded flex p-4 h-full items-center">
                                    <BadgeCheckIcon className="text-green-400 w-6 h-6 flex-shrink-0 mr-4" />
                                    <span className="title-font font-medium text-white">
                                        {skill}
                                    </span>
                                </div>
                            </div>
                    ))}
                </div>
            </div>
        </section>
    );
}



// WEBPACK FOOTER //
// ./src/components/About.js